import { makeStyles, useTheme } from '@material-ui/core';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
const useStyles = makeStyles((theme) => ({
  root: {
    userSelect: 'none',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    fill: 'currentColor',
    flexShrink: 0,
    transition: theme.transitions.create('fill', {
      duration: theme.transitions.duration.shorter,
    }),
  },
}));

function SvgPicEmptyAdditionalFees({ svgRef, ...props }) {
  const classes = useStyles();
  const theme = useTheme();
  const { color, className } = props;
  return (
    <svg
      {...props}
      viewBox="0 0 240 168"
      className={classnames(classes.root, className)}
      color={theme.colors[color] ?? color}
      ref={svgRef}
    >
      <defs>
        <filter
          x="-1.8%"
          y="-16.7%"
          width="103.6%"
          height="166.7%"
          filterUnits="objectBoundingBox"
          id="pic-empty-additional-fees_svg__c"
        >
          <feOffset dy={1} in="SourceAlpha" result="shadowOffsetOuter1" />
          <feColorMatrix
            values="0 0 0 0 0.996078431 0 0 0 0 0.807843137 0 0 0 0 0 0 0 0 1 0"
            in="shadowOffsetOuter1"
          />
        </filter>
        <filter
          x="-1.8%"
          y="-16.7%"
          width="103.6%"
          height="166.7%"
          filterUnits="objectBoundingBox"
          id="pic-empty-additional-fees_svg__e"
        >
          <feOffset dy={1} in="SourceAlpha" result="shadowOffsetOuter1" />
          <feColorMatrix
            values="0 0 0 0 0.996078431 0 0 0 0 0.807843137 0 0 0 0 0 0 0 0 1 0"
            in="shadowOffsetOuter1"
          />
        </filter>
        <filter
          x="-1.8%"
          y="-16.7%"
          width="103.6%"
          height="166.7%"
          filterUnits="objectBoundingBox"
          id="pic-empty-additional-fees_svg__g"
        >
          <feOffset dy={1} in="SourceAlpha" result="shadowOffsetOuter1" />
          <feColorMatrix
            values="0 0 0 0 0.996078431 0 0 0 0 0.807843137 0 0 0 0 0 0 0 0 1 0"
            in="shadowOffsetOuter1"
          />
        </filter>
        <rect id="pic-empty-additional-fees_svg__d" x={2} width={28} height={3} rx={1} />
        <rect id="pic-empty-additional-fees_svg__f" y={4} width={28} height={3} rx={1} />
        <rect id="pic-empty-additional-fees_svg__h" x={2} y={8} width={28} height={3} rx={1} />
        <path id="pic-empty-additional-fees_svg__a" d="M0 0h80v28H0z" />
      </defs>
      <g fill="none" fillRule="evenodd">
        <path d="M-15 7.64h240v168H-15z" />
        <path
          d="M72.04 161.64c40.2-9.93 73.96-21.64 105-12.5C214.67 160.23 233.58 126.4 225 85c-8.03-38.73-36.91-38.56-72.46-58.36-109.5-61-122.5 22-136 64s13 81.5 55.5 71z"
          fill="#E9EDFB"
        />
        <path
          d="M177 111.5c29.1 5.26 32.39 21.08 43.64 21.46-7.92 14.81-22.94 22.27-43.6 16.18-31.04-9.14-64.8 2.57-105 12.5-38.98 9.63-64.5-22.8-58.04-60.63 48.8 24.24 100.21-.86 163 10.49z"
          fill="#8F9DD6"
          opacity={0.32}
        />
        <g transform="translate(75 38)">
          <path
            d="M0 28h79.2a8.8 8.8 0 018.8 8.8v46.4a8.8 8.8 0 01-8.8 8.8H4.4A4.4 4.4 0 010 87.6V28z"
            fill="#666"
          />
          <path fill="#666" d="M0 23.16h7.82v6H0z" />
          <path
            d="M0 37.66c1.4 1.02 2.48 1.55 3.24 1.57l.07-2.2c-.72-.02-1.54-.55-2.45-1.71l-.84.66-.01 1.68zm7.28 1.57h4v-2.2h-4v2.2zm8 0h4v-2.2h-4v2.2zm8 0h4v-2.2h-4v2.2zm8 0h4v-2.2h-4v2.2zm8 0h4v-2.2h-4v2.2zm8 0h4v-2.2h-4v2.2zm8 0h4v-2.2h-4v2.2zm8 0h4v-2.2h-4v2.2zm8 0h1.02c.87 0 1.72.17 2.5.5l.84-2.04a8.78 8.78 0 00-3.34-.66h-1.02v2.2zm6.25 2.57c.7.92 1.16 2 1.31 3.17l2.19-.29c-.2-1.55-.82-3-1.76-4.22l-1.74 1.34zm1.37 7v4h2.2v-4h-2.2zm0 8v4h2.2v-4h-2.2zm0 8v4h2.2v-4h-2.2zm0 8v3.5l-.01.42 2.2.14.01-.56v-3.5h-2.2zm-1.12 7.18a6.63 6.63 0 01-2.59 2.25l.97 1.98a8.83 8.83 0 003.44-3l-1.82-1.23zm-5.95 2.92h-4v2.2h4v-2.2zm-8 0h-4v2.2h4v-2.2zm-8 0h-4v2.2h4v-2.2zm-8 0h-4v2.2h4v-2.2zm-8 0h-4v2.2h4v-2.2zm-8 0h-4v2.2h4v-2.2zm-8 0h-4v2.2h4v-2.2zm-8 0h-4v2.2h4v-2.2zm-8 0h-4v2.2h4v-2.2z"
            fill="#999"
            fillRule="nonzero"
          />
          <path
            d="M4.4 19h71.2a4.4 4.4 0 014.4 4.4V28H4.4A4.4 4.4 0 010 23.6v-.2A4.4 4.4 0 014.4 19z"
            fill="#333532"
          />
          <path d="M72 52h16a2 2 0 012 2v12a2 2 0 01-2 2H72a8 8 0 110-16z" fill="#595858" />
          <circle fill="#FECE00" cx={72} cy={60} r={4} />
          <g transform="translate(3)">
            <mask id="pic-empty-additional-fees_svg__b" fill="#fff">
              <use xlinkHref="#pic-empty-additional-fees_svg__a" />
            </mask>
            <g mask="url(#pic-empty-additional-fees_svg__b)">
              <path
                d="M3.65 19.46L64.22 3.24a4.4 4.4 0 015.38 3.1l6.53 24.35a4.4 4.4 0 01-3.11 5.39L12.45 52.3a4.4 4.4 0 01-5.39-3.12L.54 24.85a4.4 4.4 0 013.11-5.39z"
                fill="#8F9DD6"
              />
              <g transform="translate(.5 15)">
                <rect fill="#FB8F23" width={71.5} height={26.4} rx={4.4} />
                <path fill="#FFE266" d="M9.9 6.6h14.7l-2.2 7.7H7.7z" />
              </g>
            </g>
          </g>
        </g>
        <g transform="translate(52 120)">
          <use
            fill="#000"
            filter="url(#pic-empty-additional-fees_svg__c)"
            xlinkHref="#pic-empty-additional-fees_svg__d"
          />
          <use fill="#FFE266" xlinkHref="#pic-empty-additional-fees_svg__d" />
        </g>
        <g transform="translate(52 120)">
          <use
            fill="#000"
            filter="url(#pic-empty-additional-fees_svg__e)"
            xlinkHref="#pic-empty-additional-fees_svg__f"
          />
          <use fill="#FFE266" xlinkHref="#pic-empty-additional-fees_svg__f" />
        </g>
        <g transform="translate(52 120)">
          <use
            fill="#000"
            filter="url(#pic-empty-additional-fees_svg__g)"
            xlinkHref="#pic-empty-additional-fees_svg__h"
          />
          <use fill="#FFE266" xlinkHref="#pic-empty-additional-fees_svg__h" />
        </g>
        <g transform="translate(53 95)">
          <circle fill="#FFE266" cx={12.5} cy={12.5} r={12.5} />
          <circle fill="#FECE00" cx={12.5} cy={12.5} r={10.5} />
          <path fill="#FFE266" d="M2.25 19.01L18.5 2.75l4.24 4.24L6.5 23.25z" />
        </g>
      </g>
    </svg>
  );
}

SvgPicEmptyAdditionalFees.propTypes = {
  svgRef: PropTypes.any,
  className: PropTypes.string,
  color: PropTypes.string,
  fontSize: PropTypes.any,
};
SvgPicEmptyAdditionalFees.defaultProps = {
  svgRef: undefined,
  className: undefined,
  color: undefined,
  fontSize: 16,
};
const ForwardRef = React.forwardRef((props, ref) => (
  <SvgPicEmptyAdditionalFees svgRef={ref} {...props} />
));
export default ForwardRef;
